// extracted by mini-css-extract-plugin
export default {"wrap":"JF-z","fullWidth":"KF-z","hideOnDesktop":"LF-z","content":"MF-z","hasOpenedNav":"NF-z","crumbsList":"OF-z","dropdownsWrap":"PF-z"};